import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { useApiFetch } from '../../api/fetcher';
import { ACCOUNT_URL } from '../../api/urls';
import { useAuth } from '../../auth/AuthContext';
import './Header.scss';

interface HeaderProps {
	onMenuClick?: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
	const navigate = useNavigate();
	const apiFetch = useApiFetch();
	const { isAuthenticated, isInitializing } = useAuth() as any;

	const [username, setUsername] = React.useState<string>(() => `user9999@example.com`);
	const [accountName, setAccountName] = React.useState<string>(() => `Mooveno Sp. z o.o.`);
	const [isLoading, setIsLoading] = React.useState<boolean>(true);
	const attemptedRef = React.useRef(false);

	React.useEffect(() => {
		if (attemptedRef.current) return;
		if (isInitializing || !isAuthenticated) return;
		attemptedRef.current = true;
		(async () => {
			try {
				const res = await apiFetch(ACCOUNT_URL, { credentials: 'include' });
				if (!res.ok) return;
				const json = await res.json();
				setUsername(json?.username || '');
				setAccountName(json?.account_name || '');
			} catch {
				navigate('/login/');
			} finally {
				setIsLoading(false);
			}
		})();
	}, [apiFetch, navigate, isInitializing, isAuthenticated]);

	return (
		<div className="app-header d-flex justify-content-between p-1 p-md-3">
			<Button
				icon="pi pi-bars"
				className="menu-button d-block d-md-none me-1"
				onClick={onMenuClick}
				text
				aria-label="Menu"
			/>
			<div className={`d-md-none text-end ${isLoading ? ' loading' : ''}`}>
				<img
					alt='mooveno-logo'
					className="logo-mooveno"
					src={`/header/mooveno-dark-logo.svg`}
					style={{ cursor: 'pointer', }}
					onClick={() => navigate('/')} />
			</div>
			<div className="d-flex justify-content-end align-items-center user-info">
				<div className={`d-none d-md-block text-end header-user-info${isLoading ? ' loading' : ''}`}>
					<div className="username">{username || '-'}</div>
					<div className="account-name">{accountName || '-'}</div>
				</div>
			</div>
		</div>
	);
};

export default Header;
